// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__qSVPG","errorLogs":"EditorFooter_errorLogs__vSgG5"};